import { useAppQuery } from "~/hooks/useAppQuery"
import { getMyEvents } from "../server/calendar.functions"
import { calendarQueryKeys } from "../query-keys"

export function useCalendar() {
  return useAppQuery({
    queryKey: calendarQueryKeys(),
    queryFn: () => getMyEvents(),
    errorMessage: "Не удалось загрузить события",
  })
}
